module.exports = __webpack_public_path__ + "img/asd.0a2ca70f.png";